import { SxType } from '@/shared';
import MagnifyingGlassIcon from '@heroicons/react/24/solid/MagnifyingGlassIcon';
import { Close } from '@mui/icons-material';
import { IconButton, InputAdornment, OutlinedInput, SvgIcon } from '@mui/material';

export interface SearchComponenteProps {
  onChange: (value: any) => void;
  value: string;
  text: string;
  sxCard?: SxType;
  cleanFilter?:()=>void;
}

export default function SearchComponente({
  value,
  onChange,
  text,
  //sxCard,
}: Readonly<SearchComponenteProps>) {
  return (
    <OutlinedInput
      fullWidth
      placeholder={`Buscar ${text}`}
      startAdornment={
        <InputAdornment position="start">
          <SvgIcon color="action" fontSize="small">
            <MagnifyingGlassIcon />
          </SvgIcon>
        </InputAdornment>
      }
      endAdornment={
        <IconButton
          size='small'
          onClick={() => {
            onChange('');
          }}
        >
          <Close sx={{
            fontSize: 22,
            color: '#BEBEBE'
          }} />
        </IconButton>
      }
      className="custom-search-form__input"
      value={value}
      onChange={e => {
        onChange(e.target.value);
      }}
    />
  );
}
